import React, { useState, useEffect } from 'react';
import './TypingText.css';

function TypingText({ text, baseSpeed = 50, startDelay = 0, onComplete = () => {}, skipTyping = false }) {
  // Convert \n to actual newlines before starting typing
  const processedText = text.replace(/\\n/g, '\n');
  const [displayedText, setDisplayedText] = useState(skipTyping ? processedText : '');
  const [currentIndex, setCurrentIndex] = useState(skipTyping ? processedText.length : 0);
  const [typingStarted, setTypingStarted] = useState(skipTyping ? true : false);
  const [typingComplete, setTypingComplete] = useState(skipTyping ? true : false);
  
  // Show cursor first, then start typing after additional delay
  useEffect(() => {
    // If we're skipping typing, call onComplete and exit early
    if (skipTyping) {
      onComplete();
      return;
    }
    
    // First wait for the parent-specified delay
    const initialDelay = setTimeout(() => {
      // Then add an additional 500ms delay to show the cursor before typing starts
      const cursorDelay = setTimeout(() => {
        setTypingStarted(true);
      }, 500); // 0.5 second delay
      
      return () => clearTimeout(cursorDelay);
    }, startDelay);
    
    return () => clearTimeout(initialDelay);
  }, [startDelay, skipTyping, onComplete]);
  
  // Handle typing logic
  useEffect(() => {
    if (!typingStarted || skipTyping) return; // Don't start typing if delay isn't done or we're skipping
    
    if (currentIndex < processedText.length) {
      let typingSpeed = baseSpeed;
      
      // Add variation and pauses
      typingSpeed *= Math.random() * 0.6 + 0.7;
      if (Math.random() < 0.1) {
        typingSpeed += Math.random() * 100;
      }
      
      // Pause at punctuation
      if (['.', ',', '!', '?', ';', ':'].includes(processedText[currentIndex])) {
        typingSpeed += 200;
      }
      
      const timeout = setTimeout(() => {
        setDisplayedText(prev => prev + processedText[currentIndex]);
        setCurrentIndex(currentIndex + 1);
      }, typingSpeed);
      
      return () => clearTimeout(timeout);
    } else {
      // Set typing complete when we reach the end of the text
      setTypingComplete(true);
      onComplete();
    }
  }, [currentIndex, processedText, baseSpeed, typingStarted, onComplete, skipTyping]);

  return (
    <div className="typing-container">
      <div className="typing-text-wrapper">
        <pre className="typing-content">{displayedText}</pre>
        {/* Apply different class based on typing state */}
        <span className={`cursor ${typingComplete ? 'cursor-blink' : ''}`}></span>
      </div>
    </div>
  );
}

export default TypingText; 